export const ArrowPlay = () => (
  <path
    d='M7.46956 16.5991C7.47928 16.8508 7.58361 17.0896 7.76171 17.2677C7.9398 17.4457 8.17854 17.5501 8.43022 17.5598C8.68189 17.5695 8.92797 17.4839 9.11927 17.3201L16.7093 12.7301C16.8955 12.5427 17.0001 12.2893 17.0001 12.0251C17.0001 11.7609 16.8955 11.5075 16.7093 11.3201L9.11927 6.73009C8.93191 6.54384 8.67846 6.4393 8.41427 6.4393C8.15008 6.4393 7.89663 6.54384 7.70927 6.73009C7.52407 6.92002 7.42041 7.17481 7.42041 7.44009C7.42041 7.70537 7.46956 16.5991 7.46956 16.5991Z'
    fill='currentColor'
  />
)
